/**
 * File Viewer page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Injector, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ToastController, ModalController, MenuController, ActionSheetController, NavController, Platform, AlertController, NavParams } from '@ionic/angular';

import { FileMimeType } from '@taldor-ltd/angular-file-viewer';
import { DomSanitizer } from '@angular/platform-browser';
import { Functions } from '../services/functions';
import { PouchService } from '../services/pouch-service';
import { Router } from '@angular/router';
declare var cornerstone: any;
declare var cornerstoneMath: any;
declare var cornerstoneTools: any;
declare var cornerstoneWebImageLoader: any;
declare var cornerstoneWADOImageLoader: any;
declare var dicomParser: any;
declare var Hammer: any;
//import 'hammerjs';
//import Hammer from 'hammerjs';
declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}
cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWebImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

@Component({
  selector: 'page-fileviewer',
  templateUrl: 'fileviewer.html',
  styleUrls: ['fileviewer.scss'],
  // providers: [NavParams],
  encapsulation: ViewEncapsulation.None,
})
export class FileViewerPage {
  navParams: any = {};
  src: any = '';
  type = FileMimeType.PNG;
  @Input() attachment: any;
  @Input() entity: any; // for annotating image
  @Input() name = 'document';
  @Input() ispage: boolean = true;
  objectKeys = Object.keys;
  @Input() hidelist = [];
  @Input() disabledlist = [];
  @Input() inputkeys = [];
  zoom = 1;
  filetype = '';
  loaded = false;
  //element = document.getElementById('dicomImage');
  element = document.querySelector('.cornerstone-element');
  isdicom = false;
  ispdf = false;
  @Input() hidetools = false;
  showtools = false;
  currenttool: any = {
    id: '',
  };

  constructor(injector: Injector, public modalCtrl: ModalController, public toastController: ToastController, public db: PouchService, private router: Router, public alertCtrl: AlertController, public func: Functions, public actionSheetCtrl: ActionSheetController, public _DomSanitizer: DomSanitizer, public platform: Platform, public navCtrl: NavController) {
    let navParams2: any = {};
    if (router.url != '/FileViewerPage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
  }

  ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      this[key] = changes[key].currentValue;
    });
    this.ngOnInit();
  }

  getType(type) {
    if (type == 'application/pdf') {
      return FileMimeType.PDF;
    } else if (type == 'image/png') {
      return FileMimeType.PNG;
    } else if (type == 'image/jpeg') {
      return FileMimeType.JPEG;
    } else if (type == 'video/mp4') {
      return FileMimeType.MP4;
    }
  }

  zoomPDF(val) {
    this.zoom += val;
  }

  ngOnInit() {
    cornerstoneTools.init({
      mouseEnabled: true,
      touchEnabled: true,
      globalToolSyncEnabled: true,
      showSVGCursors: true,
    });
    if (this.navParams != undefined && this.navParams['attachment'] != undefined) {
      this.attachment = this.navParams['attachment'];
      //this.loadOthers();
    }
    this.loadFile(this.attachment);
  }

  fileListener($event) {
    var file = $event.target.files[0];
    this.loadFile(file);
  }

  loadFile(file) {
    if (file != undefined) {
      if (file.type == 'application/dicom') {
        this.loadAndViewDicom(file);
      } else if (file.type == 'image/png' || file.type == 'image/jpeg') {
        this.loadAndViewImage(file);
      } else {
        this.loadOthers(file);
      }
    }
  }

  loadOthers(file) {
    this.name = this.navParams['name'] || this.name;
    this.filetype = file.type != undefined ? file.type : file.content_type;
    this.type = this.getType(this.filetype);
    this.showtools = false; //hide tools
    //create url
    var url = null;
    if (navigator.msSaveBlob) {
      url = navigator.msSaveBlob(file, this.name);
    } else {
      url = window.URL.createObjectURL(file);
    }

    //assign url
    if (this.filetype == 'application/pdf') {
      this.src = url;
      this.ispdf = true;
    } else {
      this.src = this._DomSanitizer.bypassSecurityTrustUrl(url);
      this.ispdf = false;
    }
  }

  loadAndViewImage(file) {
    this.ispdf = false;
    this.isdicom = false; //switch html and condition
    this.showtools = !this.hidetools; //show tools
    setTimeout(() => {
      cornerstone.registerImageLoader('data', cornerstoneWebImageLoader.loadImage);
      /* cornerstone.registerImageLoader('http', cornerstoneWebImageLoader.loadImage);
            cornerstone.registerImageLoader('https', cornerstoneWebImageLoader.loadImage); */
      this.element = document.querySelector('.cornerstone-element');
      cornerstone.enable(this.element);
      this.loadEvents();
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          // convert image file to base64 string
          let imageId = reader.result;
          cornerstone.loadImage(imageId).then((image) => {
            cornerstone.displayImage(this.element, image);

            cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool);
            cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

            cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool);
            cornerstoneTools.setToolActive('ZoomTouchPinch', { mouseButtonMask: 1 });
          });
        },
        false
      );
      reader.readAsDataURL(file);
    }, 500);
  }

  loadEvents() {
    this.element.addEventListener('cornerstonetoolsmeasurementremoved', (event: any) => {
      this.saveState(event.detail.toolType);
    });

    /* this.element.addEventListener("cornerstonetoolsmouseclick", function (event) {
            console.log(event);
        }); */
  }

  loadAndViewDicom(file) {
    this.ispdf = false;
    this.isdicom = true; //switch html and condition
    this.showtools = true; //show tools
    setTimeout(() => {
      let imageId = cornerstoneWADOImageLoader.wadouri.fileManager.add(file);
      this.element = document.querySelector('.dicomImage');
      cornerstone.enable(this.element);
      cornerstone.loadImage(imageId).then(
        (image) => {
          //console.log(image);
          const viewport = cornerstone.getDefaultViewportForImage(this.element, image);
          /*  document.getElementById('toggleModalityLUT').checked = (viewport.modalityLUT !== undefined);
                document.getElementById('toggleVOILUT').checked = (viewport.voiLUT !== undefined); */
          cornerstone.displayImage(this.element, image, viewport);
          cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool);
          cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

          cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool);
          cornerstoneTools.setToolActive('ZoomTouchPinch', { mouseButtonMask: 1 });
        },
        function (err) {
          alert(err);
        }
      );
    }, 500);
  }

  saveState(tool = this.currenttool.id) {
    if (tool != '' && this.entity.attachment_data != undefined && this.entity.attachment_data[this.name] != undefined && this.entity.attachment_data[this.name].toolstates != undefined) {
      //shouldn't happen but do this to prevent errors
      this.entity.attachment_data[this.name].toolstates[tool] = cornerstoneTools.getToolState(this.element, tool);
      console.log(this.entity.attachment_data[this.name].toolstates[tool]);
      this.presentToast(tool + ' state has been saved', 'toast-success');
    }
  }

  action(tool) {
    //set current tool for saving state
    this.currenttool = tool;

    if (tool.className == 'ww_wc') {
      let viewport = cornerstone.getViewport(this.element);
      viewport.voi.windowWidth = tool.width;
      viewport.voi.windowCenter = tool.center;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == 'Clear') {
      //cornerstoneTools.clearElementToolState(this.element);
      cornerstone.reset(this.element);
    } else if (tool.className != '') {
      if (tool.stackneeded != true) {
        cornerstoneTools.addTool(cornerstoneTools[tool.className]);
        //load tool state if it was previously set
        if (this.entity.attachment_data != undefined && this.entity.attachment_data[this.name] != undefined && this.entity.attachment_data[this.name].toolstates != undefined && this.entity.attachment_data[this.name].toolstates[this.currenttool.id] != undefined) {
          this.entity.attachment_data[this.name].toolstates[this.currenttool.id].data.map((state) => {
            cornerstoneTools.addToolState(this.element, this.currenttool.id, state);
          });
          cornerstone.updateImage(this.element);
        }

        cornerstoneTools.setToolActive(tool.id, { mouseButtonMask: 1 });
      } else {
        //declare stack for brush tool
      }
    } else if (tool.id == 'invert') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.invert = !viewport.invert;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == 'interpolation') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.pixelReplication = !viewport.pixelReplication;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == 'hflip') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.hflip = !viewport.hflip;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == 'vflip') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.vflip = !viewport.vflip;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == 'rotate') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.rotation += 90;
      cornerstone.setViewport(this.element, viewport);
    } else if (tool.id == '') {
      const viewport = cornerstone.getViewport(this.element);
      viewport.rotation += 90;
      cornerstone.setViewport(this.element, viewport);
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  download() {
    var url = null;
    if (navigator.msSaveBlob) {
      url = navigator.msSaveBlob(this.attachment, this.name);
    } else {
      url = window.URL.createObjectURL(this.attachment);
    }
    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', this.name);
    tempLink.click();
    window.URL.revokeObjectURL(url);
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
